module.exports = __webpack_public_path__ + "static/media/ico-lineas-de-atencion.993e4807.svg";